import { render, staticRenderFns } from "./OpenHours.vue?vue&type=template&id=49ac4170"
import script from "./OpenHours.vue?vue&type=script&lang=js"
export * from "./OpenHours.vue?vue&type=script&lang=js"
import style0 from "./OpenHours.vue?vue&type=style&index=0&id=49ac4170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports